import {TotalMarketplacePurchases} from "../../../models/dashboard/marketplacePurchase/marketplacePurchaseModel";
import {adminHttpClient} from "../../../commons/adminHttpClinet";

const getTotalMarketplacePurchases = () :Promise<TotalMarketplacePurchases> => {
    return adminHttpClient.get('/api/Admin/AdminStatistics/marketplace-purchases');
}

export default getTotalMarketplacePurchases;